import React from 'react';
import { Button, ButtonVariant } from '@vimily/bonjoro-ui-components-v2/Button';
import cx from 'classnames';

import { useDragAndDropUpload } from '../hooks/use-drag-and-drop-upload';

export interface ManualUploadButtonProps {
  text?: string;
  className?: string;
  icon?: React.ReactNode;
  variant?: ButtonVariant;
  onClick?: () => void;
}

export default function ManualUploadButton({
  text = 'Upload Video',
  className,
  variant = ButtonVariant.Default,
  icon,
  onClick,
}: ManualUploadButtonProps) {
  const { openDragAndDropUploadModal } = useDragAndDropUpload();

  const buttonContent = (
    <span className='flex items-center justify-center gap-3'>
      {icon}
      {text}
    </span>
  );

  const handleOnClick = () => {
    onClick?.();
    openDragAndDropUploadModal();
  };

  return (
    <>
      <Button
        className={cx(className, '!h-10')}
        variant={variant}
        onClick={handleOnClick}
      >
        {buttonContent}
      </Button>
    </>
  );
}
